<template>
    <div v-if="paginator.last_page > 1" class="pagging">
        <a
            :class="['pagging__arrow', '_icon-pagination_arr-left', { '_disabled': paginator.current_page === 1 }]"
            @click="changePage(paginator.current_page - 1)"
        ></a>
        <ul class="pagging__list">
            <li v-for="page in totalPages" :key="page">
                <a
                    href="#"
                    :class="['pagging__item', { '_active': page === paginator.current_page }]"
                    @click.prevent="changePage(page)"
                >
                    {{ page }}
                </a>
            </li>
        </ul>
        <a
            :class="['pagging__arrow', '_icon-pagination_arr-right', { '_disabled': paginator.current_page === paginator.last_page }]"
            @click="changePage(paginator.current_page + 1)"
        ></a>
    </div>
</template>

<script>
export default {
    name: "CatalogListPagination",
    props: {
        paginator: {
            type: Object,
            required: true
        }
    },
    computed: {
        totalPages() {
            return Array.from({ length: this.paginator.last_page }, (v, k) => k + 1);
        }
    },
    methods: {
        changePage(page) {
            if (page >= 1 && page <= this.paginator.last_page) {
                this.$emit('page-changed', page);
            }
        }
    }
}
</script>

<style scoped>
.pagging__arrow {
    cursor: pointer;
}
</style>
